/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Confirm_Scene_Description_Job_TextInputs */



/**
* | output |
* | --- |
* | "This job will cost approximately ${cost} USD. Do you want to proceed?" |
*
* @param {Confirm_Scene_Description_Job_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_scene_description_job_text = /** @type {((inputs: Confirm_Scene_Description_Job_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Scene_Description_Job_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce travail coûtera environ $${i?.cost} USD. Voulez-vous continuer ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieser Auftrag kostet ungefähr ${i?.cost} USD. Möchten Sie fortfahren?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questo lavoro costerà circa $${i?.cost} USD. Vuoi procedere?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Эта работа обойдется примерно в $${i?.cost} долларов США. Вы хотите продолжить?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Este trabajo tendrá un costo aproximado de $${i?.cost} USD. ¿Desea continuar?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`这项工作大约需要花费 $${i?.cost} 美元。您是否要继续？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`この作業には約$${i?.cost}米ドルの費用がかかります。続行しますか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इस काम में लगभग $${i?.cost} USD का खर्च आएगा। क्या आप आगे बढ़ना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Este serviço custará aproximadamente $${i?.cost} USD. Deseja prosseguir?`)
	return /** @type {LocalizedString} */ (`This job will cost approximately $${i?.cost} USD. Do you want to proceed?`)
});